import script from "./VolunteersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VolunteersTable.vue?vue&type=script&setup=true&lang=ts"

import "./VolunteersTable.vue?vue&type=style&index=0&id=076e5c85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076e5c85"]])

export default __exports__